import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CAMPAIGNS_ACTION_TYPE } from '../actions';

const initialState = {
  byId: {},
  audience: null,
  enrollments: [],
};

const campaignsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGNS:
        draft.byId = payload || {};
        break;

      case CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGN:
      case CAMPAIGNS_ACTION_TYPE.SAVE_CAMPAIGN:
        draft.byId[payload.id] = payload;
        break;

      case CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGN_AUDIENCE:
        draft.audience = payload;
        break;

      case CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGN_ENROLLMENTS:
        draft.enrollments = payload || [];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default campaignsReducer;
